const initState = { vacancies: []};

export function vacanciesFilterSave(state = initState, action) {

    switch (action.type) {
        case 'PUT_DATA':
            return {...state, vacancies: action.payload};
    }
    return state;
}